import { render, staticRenderFns } from "./attention-recommd.vue?vue&type=template&id=cf5ed7e6&scoped=true"
import script from "./attention-recommd.vue?vue&type=script&lang=js"
export * from "./attention-recommd.vue?vue&type=script&lang=js"
import style0 from "./attention-recommd.vue?vue&type=style&index=0&id=cf5ed7e6&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cf5ed7e6",
  null
  
)

export default component.exports